import type { QuotaListItem } from "@/domain/fiscal/quotaList";
import {
  getBeneficiaryRepository,
  getFiscalQuotaRepository,
  getInvestorRepository,
} from "@/infrastructure/di";

const PAGE_SIZE = 20;

export const searchInvestmentBeneficiaries = async (search: string, page = 0) => {
  const result = await getBeneficiaryRepository().getBeneficiaries({
    search: search || undefined,
    limit: PAGE_SIZE,
    offset: page * PAGE_SIZE,
  });
  return {
    options: result.beneficiaries.map((beneficiary) => ({
      value: beneficiary.uuid,
      label: beneficiary.name,
    })),
    hasMore: result.beneficiaries.length === PAGE_SIZE,
  };
};

export const searchInvestmentInvestors = async (search: string, page = 0) => {
  const result = await getInvestorRepository().list({
    search: search || undefined,
    limit: PAGE_SIZE,
    offset: page * PAGE_SIZE,
  });
  return {
    options: result.investors.map((investor) => ({
      value: investor.uuid,
      label: investor.display_name,
    })),
    hasMore: result.investors.length === PAGE_SIZE,
  };
};

export interface QuotaOptionFormat {
  label: (quota: QuotaListItem) => string;
  description: (quota: QuotaListItem) => string;
  /** The quota's full name, as the trigger and the dialogs show it. */
  name: (quota: QuotaListItem) => string;
}

export const searchInvestmentQuotas = async (
  search: string,
  page: number,
  format: QuotaOptionFormat,
  beneficiaryUuid?: string,
) => {
  const result = await getFiscalQuotaRepository().getQuotas({
    search: search || undefined,
    beneficiary_uuid: beneficiaryUuid ? [beneficiaryUuid] : undefined,
    limit: PAGE_SIZE,
    offset: page * PAGE_SIZE,
  });
  return {
    options: result.quotas.map((quota) => ({
      value: quota.uuid,
      label: format.label(quota),
      description: format.description(quota),
      deductionAvailable: quota.money.deduction.available,
      state: quota.state,
      promoter: quota.beneficiary.name,
      name: format.name(quota),
    })),
    hasMore: result.quotas.length === PAGE_SIZE,
  };
};
